import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  heading: {
    id: 'jira-common.ListProjectForms.Heading',
    defaultMessage: 'Delete “{formName}”?'
  },
  cancel: {
    id: 'jira-common.ListProjectForms.Cancel',
    defaultMessage: 'Cancel'
  },
  delete: {
    id: 'jira-common.ListProjectForms.Delete',
    defaultMessage: 'Delete'
  },
  deleteFormSuccessFlagTitle: {
    id: 'jira-common.ListProjectForms.DeleteFormSuccess',
    defaultMessage: '“{formName}” deleted',
    description: 'The title for the flag shown on successful deletion of a form.'
  },
  willRemoveRequestTypesMsg: {
    id: 'jira-common.ListProjectForms.WillRemoveRequestTypesMsg',
    defaultMessage: 'Deleting this form will remove it from the following request types: '
  },
  willRemoveIssueTypesMsg: {
    id: 'jira-common.ListProjectForms.WillRemoveIssueTypesMsg',
    defaultMessage: 'Deleting this form will remove it from the following issue types: '
  },
  futureIssueMessage: {
    id: 'jira-common.ListProjectForms.FutureIssueMessage',
    defaultMessage: 'Future issues created using these issue types will no longer include this form:'
  },
  futureRequestMessage: {
    id: 'jira-common.ListProjectForms.FutureRequestMessage',
    defaultMessage: 'Future requests created using these request types will no longer include this form.'
  },
  affectExistingIssues: {
    id: 'jira-common.ListProjectForms.AffectExistingIssues',
    defaultMessage: 'This won’t affect existing issues that already use this form, or any copies of this form in other projects.'
  },
  learnMoreLink: {
    id: 'jira-common.ListProjectForms.LearnMoreLink',
    defaultMessage: 'Learn more about deleting forms.'
  }
});